import * as types from 'commons-general/actions/accountActionTypes.js';

/* eslint-disable import/prefer-default-export */

export function setAccount(account) {
    return {
        type: types.SET_ACCOUNT,
        account,
    };
}
